import React from "react";
import { toast } from "react-toastify";

const CampaignSchedule = ({ formData, setFormData, next }) => {

  const handleNext = () => {
    if (!formData.campaignName?.trim()) {
      toast.error("Campaign name is required");
      return;
    }

  if (!formData.campPurpose) {
  toast.error("Please select campaign purpose");
  return;
}

    if (!formData.startDate) {
      toast.error("Start date is required");
      return;
    }

    if (!formData.startTime) {
      toast.error("Start time is required");
      return;
    }

    if (formData.campaignType === "schedule") {
      if (!formData.endDate) {
        toast.error("End date is required for scheduled campaign");
        return;
      }

      if (!formData.endTime) {
        toast.error("End time is required for scheduled campaign");
        return;
      }

      if (!formData.interval) {
        toast.error("Please enter interval value");
        return;
      }
    }

    next();
  };

  return (
    <>
    <div className="w-full px-6 py-2 space-y-2 montserrat-font-1">
      <div>
        <h2 className="text-2xl font-semibold mb-1">Campaign Name</h2>

        <p className="text-sm text-gray-500 italic mb-2 montserrat-font-2">
          Choose a descriptive name that reflects your target audience and
          campaign goals.
        </p>

        <input
          type="text"
          placeholder="Enter campaign name"
          maxLength={25}
          value={formData.campaignName}
          onChange={(e) =>
            setFormData({ ...formData, campaignName: e.target.value })
          }
          className="w-full md:w-1/2 border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
        />
      </div>

      {/* Campaign Purpose */}
      <div className=" montserrat-font-1">
        <label className="block text-sm font-medium mb-2">
          Campaign Purpose
        </label>

        <select
  value={formData.campPurpose || ""}
  onChange={(e) =>
    setFormData((prev) => ({
      ...prev,
      campPurpose: e.target.value,
    }))
  }
  className="w-full border rounded-lg px-4 py-3"
>
  <option value="">Select Purpose</option>
  <option value="1">Lead Generation</option>
  <option value="2">Marketing & Awareness</option>
</select>
      </div>

      {/* Type of Campaign */}
      <div>
        <h3 className="text-xl font-semibold mb-1">Type of Campaign</h3>

        <p className="text-sm text-gray-500 italic mb-4 montserrat-font-2">
          Instant campaigns send messages immediately, while scheduled campaigns
          deliver them at a set time.
        </p>

        <div className="flex gap-10 montserrat-font-1">
          {/* Default = Schedule */}
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              checked={formData.campaignType === "schedule"}
              onChange={() =>
                setFormData({ ...formData, campaignType: "schedule" })
              }
              className="accent-blue-600"
            />
            Schedule It
          </label>

          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              checked={formData.campaignType === "instant"}
              onChange={() =>
                setFormData({ ...formData, campaignType: "instant" })
              }
              className="accent-blue-600"
            />
            Instant Campaign
          </label>
        </div>
      </div>

      {/* Schedule Section */}
      {formData.campaignType === "schedule" ? (
        <div className="bg-gray-50 p-5 rounded-xl border space-y-5 montserrat-font-1">
          <div>
            <h3 className="text-xl font-semibold mb-1">
              Schedule Date and Time
            </h3>
            <p className="text-sm text-gray-500 italic montserrat-font-2">
              Set the start and end date & time for your campaign.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 montserrat-font-1">
            {/* Start Date */}
            <div>
              <label className="block text-sm mb-2">Start Date</label>
              <input
                type="date"
                value={formData.startDate}
                onChange={(e) =>
                  setFormData({ ...formData, startDate: e.target.value })
                }
                className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* End Date */}
            <div>
              <label className="block text-sm mb-2">End Date</label>
              <input
                type="date"
                value={formData.endDate || ""}
                onChange={(e) =>
                  setFormData({ ...formData, endDate: e.target.value })
                }
                className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Start Time */}
            <div>
              <label className="block text-sm mb-2">Start Time</label>
              <input
                type="time"
                value={formData.startTime}
                onChange={(e) =>
                  setFormData({ ...formData, startTime: e.target.value })
                }
                className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* End Time */}
            <div>
              <label className="block text-sm mb-2">End Time</label>
              <input
                type="time"
                value={formData.endTime || ""}
                onChange={(e) =>
                  setFormData({ ...formData, endTime: e.target.value })
                }
                className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Interval Unit */}
            <div>
              <label className="block text-sm mb-2">Select Interval Unit</label>
              <select
                value={formData.intervalUnit || "minutes"}
                onChange={(e) =>
                  setFormData({ ...formData, intervalUnit: e.target.value })
                }
                className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              >
                <option value="minutes">Minutes</option>
                <option value="hours">Hours</option>
                <option value="days">Days</option>
              </select>
            </div>

            {/* Interval Value */}
            <div>
              <label className="block text-sm mb-2">Select Interval</label>
              <input
                type="number"
                min="1"
                value={formData.interval || ""}
                onChange={(e) =>
                  setFormData({ ...formData, interval: e.target.value })
                }
                placeholder="Enter interval"
                className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>
      ) : (
        /* Instant Campaign Layout */
        <div className="bg-gray-50 p-8 rounded-xl border space-y-6 montserrat-font-1">
          <div>
            <h3 className="text-xl font-semibold mb-1">
              Instant Campaign Start Time
            </h3>
            <p className="text-sm text-gray-500 italic montserrat-font-2">
              Set the start date and time for immediate delivery.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {/* Start Date */}
            <div>
              <label className="block text-sm mb-2">Start Date</label>
              <input
                type="date"
                value={formData.startDate}
                onChange={(e) =>
                  setFormData({ ...formData, startDate: e.target.value })
                }
                className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Start Time */}
            <div>
              <label className="block text-sm mb-2">Start Time</label>
              <input
                type="time"
                value={formData.startTime}
                onChange={(e) =>
                  setFormData({ ...formData, startTime: e.target.value })
                }
                className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>
      )}

      {/* Navigation Buttons */}
      <div className="flex justify-end gap-6 pt-2 montserrat-font-1">
        <button className="px-6 py-2 border rounded-lg text-gray-600 hover:bg-gray-100">
          Previous
        </button>

        <button
          onClick={handleNext}
          className="px-8 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
        >
          Next
        </button>
      </div>
    </div>
    </>
  );
};

export default CampaignSchedule;
